export default __webpack_public_path__ + "static/media/06_father.934d4a29.png";